/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import ReactTable from 'react-table'
import createTable from 'react-table-hoc-fixed-columns'
import DatePicker from '../common/DatePicker'
import moment from 'moment'
import 'react-table/react-table.css'

import CSVExportModal from './CSVExportModal'
import profile_avatar from '../../assets/images/mock/StockProfilePic.png'

const ReactTableFixedColumns = createTable(ReactTable)

const buildHeaders = t => [
  { label: t('common.field.firstName'), key: 'firstname' },
  { label: t('common.field.lastName'), key: 'lastname' },
  { label: t('common.field.date'), key: 'date' },
  { label: t('reports.common.level'), key: 'division' },
  { label: t('common.golf.yardage'), key: 'yardage' },
  { label: t('reports.communityRoundsTable.type'), key: 'type' },
  { label: t('common.golf.holes'), key: 'holes' },
  { label: t('common.golf.score'), key: 'score' },
  { label: t('common.golf.greens'), key: 'greens' },
  { label: t('common.golf.putts'), key: 'putts' },
]

class CommunityRoundsTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showModal: false,
      dataLoader: false,
      data: [],
    }
  }
  toggleModal = () => {
    this.setState({
      showModal: !this.state.showModal,
    })
  }

  createData = () => {
    const { data } = this.props
    const rounds = data[0].rounds
    const tempData = []
    this.setState({ dataLoader: true })
    if (rounds.length > 0) {
      rounds.map(round => {
        const firstname = round.user.first_name
        const lastname = round.user.last_name
        const date = round.activity_date
        const yardage = round.yardage
        const type = round.play_type.name
        const holes = round.holes
        const score = round.score
        const greens = round.greens
        const putts = round.putts

        tempData.push({
          firstname,
          lastname,
          date: moment(date).format('MM-DD-YYYY'),
          division: this.renderDivision(yardage),
          yardage,
          type,
          holes,
          score,
          greens,
          putts,
        })
      })
    }

    this.setState({
      showModal: !this.state.showModal,
      data: tempData,
    })
  }
  renderUserAvatarCell = props => (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
    <div
      className='number'
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
      }}
      key={props.value ? props.value.id : null}
      onClick={() =>
        this.props.toProfile(props.value ? props.value.id : null)
      }
    >
      <div className='small-round-image-wrapper'>
        {props.value ? (
          <img
            className='round-image'
            src={
              props.value.avatar
                ? props.value.avatar.file_url
                : profile_avatar
            }
            alt={
              props.value
                ? `${props.value.first_name} ${props.value.last_name}`
                : ''
            }
          />
        ) : null}
      </div>
    </div>
  )
  renderDivision = yardage => {
    const { t } = this.props
    switch (yardage) {
      case 225:
        return t('reports.communityRoundsTable.levelNumber', { number: 1 })
      case 450:
        return t('reports.communityRoundsTable.levelNumber', { number: 2 })
      case 900:
        return t('reports.communityRoundsTable.levelNumber', { number: 3 })
      case 1350:
        return t('reports.communityRoundsTable.levelNumber', { number: 4 })
      case 1800:
        return t('reports.communityRoundsTable.levelNumber', { number: 5 })
      default:
        if (yardage >= 1500 && yardage !== 1800) {
          return t('reports.communityRoundsTable.fullTee')
        } else if (yardage < 225) {
          return t('reports.communityRoundsTable.levelNumber', { number: 1 })
        } else {
          return ''
        }
    }
  }
  renderDivisionCell = props => (
    <div
      className='number'
      style={{
        backgroundColor: '',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: '#2b3843' }}>
        {this.renderDivision(props.value)}
      </div>
    </div>
  )
  renderTableCell = props => (
    <div
      className='number'
      style={{
        backgroundColor: '',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: '#2b3843' }}>{props.value}</div>
    </div>
  )

  renderActivityDateCell = props => (
    <div
      className='number'
      style={{
        backgroundColor: '',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: '#2b3843' }}>
        {moment(props.value).format('MM-DD-YYYY')}
      </div>
    </div>
  )
  renderTable = () => {
    const {
      t,
      title,
      startDate,
      endDate,
      handleStartDateChanged,
      handleEndDateChanged,
    } = this.props
    const columns = [
      {
        Header: '',
        accessor: 'user',
        Cell: props => this.renderUserAvatarCell(props),
        sortable: false,
        fixed: true,
      },
      {
        Header: t('common.field.firstName'),
        accessor: 'user.first_name',
        fixed: true,
      },
      {
        Header: t('common.field.lastName'),
        accessor: 'user.last_name',
        fixed: true,
      },
      {
        Header: t('common.field.date'),
        accessor: 'activity_date',
        Cell: props => this.renderActivityDateCell(props),
      },
      {
        Header: t('reports.common.level'),
        accessor: 'yardage',
        Cell: props => this.renderDivisionCell(props),
      },
      {
        Header: t('common.golf.yardage'),
        accessor: 'yardage',
        Cell: props => this.renderTableCell(props),
      },
      {
        Header: t('reports.communityRoundsTable.type'),
        accessor: 'play_type.name',
        Cell: props => this.renderTableCell(props),
      },
      {
        Header: t('common.golf.holes'),
        accessor: 'holes',
        Cell: props => this.renderTableCell(props),
        style: { padding: 0 },
      },
      {
        Header: t('common.golf.score'),
        accessor: 'score',
        Cell: props => this.renderTableCell(props),
        style: { padding: 0 },
      },
      {
        Header: t('common.golf.greens'),
        accessor: 'greens',
        Cell: props => this.renderTableCell(props),
        style: { padding: 0 },
      },
      {
        Header: t('common.golf.putts'),
        accessor: 'putts',
        Cell: props => this.renderTableCell(props),
        style: { padding: 0 },
      },
    ]

    return (
      <div className='container my-5 animated fadeIn'>
        <div className='row mb-5 d-flex align-items-center'>
          <div className='col-md-4'>
            <h2>{title}</h2>
          </div>
          <div className='col-md-4 d-flex align-items-center'>
            <div>
              <p className='m-0'>{t('common.field.startDate')}</p>
              <DatePicker
                name={'start-date'}
                id={'start-date'}
                startDate={startDate}
                endDate={endDate}
                type={'date'}
                className={'col-12 form-control'}
                onChange={handleStartDateChanged}
                placeholder={t('common.field.startDate')}
                selected={startDate}
                error={''}
              />
            </div>

            <div className='ml-2'>
              <p className='m-0'>{t('common.field.endDate')}</p>
              <DatePicker
                name={'end-date'}
                id={'end-date'}
                startDate={startDate}
                endDate={endDate}
                type={'date'}
                className={'col-12 form-control'}
                onChange={handleEndDateChanged}
                placeholder={t('common.field.endDate')}
                selected={endDate}
                error={''}
              />
            </div>
          </div>
          <div className='col-md-4'>
            <button
              className='btn btn-sm btn-block'
              onClick={() => this.props.goBack()}
            >
              <i
                className='fa fa-arrow-left text-white mr-1'
                aria-hidden='true'
              />{' '}
              {t('reports.common.viewAnotherReport')}
            </button>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <ReactTableFixedColumns
              data={
                this.props.data[0] && !this.props.loader
                  ? this.props.data[0].rounds
                  : []
              }
              columns={columns}
              defaultPageSize={10}
              loading={this.props.loader}
              loadingText={t('reports.common.loadingReport')}
              noDataText={
                this.props.data[0]
                  ? t('reports.communityRoundsTable.chooseDateRange')
                  : t('reports.common.noDataFound')
              }
            />
          </div>
        </div>
        <button onClick={this.createData} className='mt-3 btn btn-success'>
          {t('reports.common.exportAsCsv')}
        </button>
      </div>
    )
  }

  render() {
    const { t } = this.props
    return (
      <div>
        {this.renderTable()}
        <CSVExportModal
          headers={buildHeaders(t)}
          data={this.state.data}
          showModal={this.state.showModal}
          toggleModal={this.toggleModal}
          reportType={t('reports.communityRoundsTable.reportType')}
          filename={'community-rounds-report.csv'}
        />
      </div>
    )
  }
}

export default withTranslation()(CommunityRoundsTable)
